import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { filter, of, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';
import { OAuthService } from 'angular-oauth2-oidc';

import { appFeature } from '@app/core/store/app.reducer';
import { CompanyStatus } from '@app/shared/enums/company.enums';

export const isUserFullyRegisteredGuard: CanActivateFn = () => {
  const router = inject(Router);
  const store = inject(Store);
  const oAuthService = inject(OAuthService);

  return store.select(appFeature.selectUser).pipe(
    filter(Boolean),
    switchMap(user => {
      if (user.company) {
        if (
          oAuthService.hasValidAccessToken() &&
          (!user.companyId ||
            user.company.companyStatus ===
              CompanyStatus.PendingUploadingFiles ||
            user.company.companyStatus ===
              CompanyStatus.PendingSelectingCategories ||
            user.company.companyStatus === CompanyStatus.Unregistered)
        ) {
          router.navigate(['/signup']);
          return of(false);
        } else {
          return of(true);
        }
      } else {
        router.navigate(['/signup']);
        return of(false);
      }
    })
  );
};
